const Button = ({ onClick, children }) => {
	return (
		<button className={"border-0 text-4xl leading-4 w-16 h-16 rounded-lg cursor-pointer select-none bg-blue-500 text-slate-200 hover:brightness-125 hover:transition-all text-center flex items-center justify-center"} type={"button"} onClick={onClick}>
			{children}
		</button>
	)
}

export default Button